import React from "react";
import PropTypes from "prop-types";
import screenfull from "screenfull";
import { exitFullScreen, enterFullScreen } from "../../utils/screen";
import { isMobile } from "../../utils/ResponsiveUtils";

function FullScreenButton({ containerId }) {
  const handleFullScreenClick = () => {
    if (screenfull.isFullscreen) {
      exitFullScreen();
    } else {
      enterFullScreen();
    }
  };
  const { buildUrl } = document.getElementById(
    "irobot-embedded-interactive-experience"
  ).dataset;
  return (
    <>
      <button
        type="button"
        className="full__screen-btn"
        onClick={handleFullScreenClick}
      >
        <img
          src={`${buildUrl}/images/player-controls/full-screen-icon.png`}
          alt="Enter/Exit fullscreen"
        />
      </button>
      <style jsx="true">
        {`
          #${containerId} .full__screen-btn {
            display: ${screenfull.isEnabled ? "flex" : "none"} !important;
            box-shadow: none !important;
            border: 0 !important;
            border-radius: 50% !important;
            background-color: transparent !important;
            background-image: none !important;
            background-repeat: no-repeat !important;
            background-size: cover !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 0 !important;

            ${isMobile()
              ? `
              width: 44px !important;
              height: 44px !important;
            `
              : `
              width: 72px !important;
              height: 72px !important;
            `}
          }
          #${containerId} .full__screen-btn > img {
            width: 45% !important;
            height: auto !important;
            cursor: pointer !important;
          }

          #${containerId} .full__screen-btn&:focus,
          #${containerId} .full__screen-btn&:active {
            outline: 0 !important;
          }
        `}
      </style>
    </>
  );
}

FullScreenButton.propTypes = {
  containerId: PropTypes.string.isRequired,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
};

FullScreenButton.defaultProps = {
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};

export default FullScreenButton;
